import { useEffect, useState } from 'react';
import { useFeature } from '../featureFlags/FeatureGate';
import { useHasPermission } from '../PermissionGate';
import { fetchAssignable, type AssignableRole } from './roleCenterApi';
import { ROLE_CENTER_FLAG } from './roleAccessApi';

/**
 * Role własne z centrum ról przy kontach (decyzja użytkownika 22.10.2026,
 * przełącznik `roleCenter`, S-22.10-01): formularz konta i lista kont znają
 * je z API (`GET /role-center/assignable` — role, które zalogowany może
 * nadać). Wyłączony przełącznik albo brak zarządzania użytkownikami —
 * pusta lista, jak dotąd.
 */

let cache: Promise<AssignableRole[]> | null = null;

/** Tylko dla testów. */
export function resetCustomRolesCache(): void {
  cache = null;
}

export function useCustomRoles(): AssignableRole[] {
  const on = useFeature(ROLE_CENTER_FLAG);
  const canManage = useHasPermission('MANAGE_USERS');
  const [roles, setRoles] = useState<AssignableRole[]>([]);
  useEffect(() => {
    if (!on || !canManage) {
      setRoles([]);
      return;
    }
    let alive = true;
    if (!cache) {
      cache = fetchAssignable().catch(() => {
        cache = null;
        return [];
      });
    }
    void cache.then((all) => alive && setRoles(all.filter((r) => !r.system)));
    return () => {
      alive = false;
    };
  }, [on, canManage]);
  return roles;
}
